// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__xREoI","image":"style_image__3wjhR","copy":"style_copy__25Ivu","title":"style_title__VRJUo","text":"style_text__3GKB5"};